import { DataView } from 'primereact/dataview';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import DateItem from './DateItem';
import DateManager from './DateManager';

function DatePage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { navigationContext } = useNavigationContext();
  const [dateList, setDateList] = useState([]);
  const [dateDetail, setDateDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState(undefined);
  const [showpastDateList, setShowPastDateList] = useState(false);

  useEffect(() => {
    fetchDateList();
  }, [typeFilter, showpastDateList, navigationContext]);

  const fetchDateList = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/date/?date=${showpastDateList && 'past'}&type=${typeFilter || ''}`
    ).then((res) => {
      setDateList(res);
    });
  };

  const handleClickDate = (date) => {
    setDateDetail(date);
    setPanelIsOpen(true);
  };

  useEffect(() => {
    if (panelIsOpen === false) {
      setDateDetail(undefined);
    }
  }, [panelIsOpen]);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newDateAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une date',
    icon: 'pi-plus'
  };

  const createDate = async (dateForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'quatrebis',
      `/cu/${accountContext.id}/date/`,
      'La date a bien été ajouté',
      JSON.stringify(dateForm)
    ).then(() => {
      fetchDateList();
      setPanelIsOpen(false);
      setLoading(false);
      setDateDetail(undefined);
    });
  };

  const updateDate = async (dateForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'quatrebis',
      `/cu/${accountContext.id}/date/${dateDetail.id}/`,
      'La date a bien été modifié',
      JSON.stringify(dateForm)
    ).then(() => {
      fetchDateList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const deleteDate = async (date) => {
    await privateFetch(
      'DELETE',
      'quatrebis',
      `/cu/${accountContext.id}/date/${date.id}/`,
      'La date a bien été supprimé'
    ).then(() => {
      fetchDateList();
      setDateDetail(undefined);
    });
  };

  const itemTemplate = (date) => (
    <DateItem date={date} handleClickDate={() => handleClickDate(date)} />
  );

  const dateFilters = (
    <div className="flex flex-row flex-wrap gap-2 justify-start">
      <div className="flex flex-row flex-wrap gap-2 ">
        <div className="fit-content mb-4">
          <SelectButton
            value={showpastDateList}
            onChange={(e) => setShowPastDateList(e.value)}
            options={CONSTANT.quatrebis.selectButtonDCodeOptions}
            className="rounded-full"
          />
        </div>
        <div className="fit-content mb-4">
          <Dropdown
            value={typeFilter}
            options={CONSTANT.quatrebis.dateType}
            optionLabel="label"
            onChange={(e) => setTypeFilter(e.value)}
            placeholder="Filtrer par Type"
            className="grow rounded-full pl-2"
            filter
            showClear
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Rendez-vous D-code" labelAction={handleClickDate} action={newDateAction}>
        {dateFilters}
        <DataView
          value={dateList}
          itemTemplate={itemTemplate}
          className="pb-20"
          emptyMessage="Aucune date trouvé"
        />
      </PageWrapper>
      <DateManager
        isOpen={panelIsOpen}
        onClose={() => {
          setPanelIsOpen(false);
        }}
        date={dateDetail}
        onCreate={createDate}
        onUpdate={updateDate}
        loading={loading}
        setPanelIsOpen={setPanelIsOpen}
        setDateDetail={setDateDetail}
        handleDelete={deleteDate}
      />
    </div>
  );
}

export default DatePage;
